// redux/slices/allotCustomerStore.js
import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  bpCode: null,
  bpName: "",
  lineOfBusiness: "",
  lineOfBusinessCode: null,
  postingDate: dayjs(),
  ToDate: null,
  deliveryDate: null,
  TransportationBy: "",
  CustomerRefNum: "",
  poRef: "",
  remarks: "",
  items: [],
};

const allotCustomerSlice = createSlice({
  name: "allotCustomerStore",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateItems: (state, action) => {
      state.items = action.payload;
    },
    resetFormData: (state) => {
      return {
        ...initialState,
        postingDate: dayjs(), // Keep current date
      };
    },
    resetState: () => initialState,
  },
});

export const { updateFormData, updateItems, resetFormData, resetState } =
  allotCustomerSlice.actions;
export default allotCustomerSlice.reducer;
